import { Container } from "./style";
import { isMobile } from "react-device-detect";


export default function AdvisePage() {
  return (
    <Container>
      <div className="inner page_inner">
        <strong className={isMobile ? 'fs20' : 'fs30'}>아래 연락처로 구독 문의 바랍니다.</strong>
        <p className="flex ai-c jc-c wrap">
          <a href="tel:010-8415-0997" className={isMobile ? 'fs14' : 'fs16'}>010-8415-0997</a>
          <span className={isMobile ? 'fs14' : 'fs16'}>(평일 10:00~18:00)</span>
        </p>
        <a href="mailto:kalhi@naver.com" className={isMobile ? 'fs14' : 'fs16'}>kalhi@naver.com</a>
      </div>
    </Container>
  )
}